import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { typographyTheme } from '~typography';
import formTheme from '../../styles/formTheme';
var Select = styled.select.withConfig({
  displayName: "Select",
  componentId: "sc-1chwooj-0"
})(["appearance:none;background-color:", ";background-image:", ";background-position:", ";background-repeat:no-repeat;background-size:", ";border-color:", ";border-style:solid;border-top-left-radius:", ";border-top-right-radius:", ";border-width:0 0 1px;color:", ";display:block;font-family:", ";font-size:", ";height:", ";padding:", " ", " ", " ", ";transition:background 0.3s ease-in 0.1s;width:100%;&:focus{background-color:", ";color:transparent;outline:0;}", " ", " &::-ms-expand{display:none;}&:focus::-ms-value{background:transparent;color:", ";}", ""], function (_ref) {
  var theme = _ref.theme,
      skin = _ref.skin;
  return _get(theme, "form.input." + skin + ".backgroundColor", formTheme.form.input[skin].backgroundColor);
}, function (_ref2) {
  var theme = _ref2.theme,
      skin = _ref2.skin;
  return "url(\"data:image/svg+xml;charset=utf8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201792%201792%22%3E%0A%20%20%3Cpath%20fill%3D%22" + _get(theme, "form.label." + skin + ".color", formTheme.form.label[skin].color).replace('#', '%23') + "%22%20d%3D%22M1408%20704c0%2017.3-6.3%2032.3-19%2045l-448%20448c-12.7%2012.7-27.7%2019-45%2019s-32.3-6.3-45-19L403%20749c-12.7-12.7-19-27.7-19-45s6.3-32.3%2019-45%2027.7-19%2045-19h896c17.3%200%2032.3%206.3%2045%2019s19%2027.7%2019%2045z%22%2F%3E%0A%3C%2Fsvg%3E\")";
}, "calc(100% - " + rem(4) + ") 68%", rem(16), function (_ref3) {
  var theme = _ref3.theme,
      skin = _ref3.skin;
  return _get(theme, "form.input." + skin + ".borderColor", formTheme.form.input[skin].borderColor);
}, function (_ref4) {
  var theme = _ref4.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref5) {
  var theme = _ref5.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref6) {
  var theme = _ref6.theme,
      skin = _ref6.skin;
  return _get(theme, "form.label." + skin + ".color", formTheme.form.label[skin].color);
}, function (_ref7) {
  var theme = _ref7.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (_ref8) {
  var theme = _ref8.theme;
  return rem(_get(theme, 'form.input.fontSize', formTheme.form.input.fontSize));
}, function (_ref9) {
  var theme = _ref9.theme;
  return rem(_get(theme, 'form.input.height', formTheme.form.input.height));
}, rem(14), rem(32), rem(6), rem(12), function (_ref10) {
  var theme = _ref10.theme,
      skin = _ref10.skin;
  return _get(theme, "form.input." + skin + ".backgroundColorFocus", formTheme.form.input[skin].backgroundColorFocus);
}, function (_ref11) {
  var theme = _ref11.theme,
      skin = _ref11.skin,
      selected = _ref11.selected;
  return selected && css(["color:", ";padding-top:", ";&:focus{color:", ";}"], _get(theme, "form.input." + skin + ".color", formTheme.form.input[skin].color), rem(24), _get(theme, "form.label." + skin + ".color", formTheme.form.label[skin].color));
}, function (_ref12) {
  var disabled = _ref12.disabled,
      skin = _ref12.skin,
      theme = _ref12.theme;
  return disabled && css(["background-image:", ";border-style:dotted;color:", ";cursor:not-allowed;"], "url(\"data:image/svg+xml;charset=utf8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%201792%201792%22%3E%0A%20%20%3Cpath%20fill%3D%22" + _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled).replace('#', '%23') + "%22%20d%3D%22M1408%20704c0%2017.3-6.3%2032.3-19%2045l-448%20448c-12.7%2012.7-27.7%2019-45%2019s-32.3-6.3-45-19L403%20749c-12.7-12.7-19-27.7-19-45s6.3-32.3%2019-45%2027.7-19%2045-19h896c17.3%200%2032.3%206.3%2045%2019s19%2027.7%2019%2045z%22%2F%3E%0A%3C%2Fsvg%3E\")", _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled));
}, function (_ref13) {
  var theme = _ref13.theme,
      skin = _ref13.skin;
  return _get(theme, "form.input." + skin + ".color", formTheme.form.input[skin].color);
}, function (_ref14) {
  var hideLabel = _ref14.hideLabel,
      theme = _ref14.theme;
  return hideLabel && css(["background-position-y:55%;height:", ";padding-top:", ";"], rem(_get(theme, 'form.input.heightNoLabel', formTheme.form.input.heightNoLabel)), rem(12));
});
export default Select;